var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{staticClass:"ver"},[_vm._v("Copyright © 2020 GoWork.la. All Rights Reserved. Ver 1.1.3")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }